export enum COURSE_LEVELS {
	BEGINNER = "beginner",
	MIDDLE = "intermediate",
	ADVANCED = "advanced",
}
